/**
 * Canonical plan copy for /pricing and main landing #pricing (single source of truth).
 *
 * Pricing page totals: modules + AI credit tier monthlyPrice.
 * Starter: $45 base modules + credits (e.g. 45 + 100 = 145 at default tier).
 * Growth: $6 × billed active users + credits (e.g. 6×25 + 100 = 250 at tier 1).
 */
const PLAN_SUB_DISCLAIMER = "* Base price listed. Total depends on options chosen."

/** Monthly $ for People/Recruiting modules (flat); ignored when modulesPerUserMonthly > 0. */
export function planModulesMonthly(plan, billedUsers) {
	const per = plan.modulesPerUserMonthly ?? 0
	if (per > 0) return per * billedUsers
	return plan.modulesMonthlyFlat ?? 0
}

export const PRICING_PLANS_CONTENT = {
	starter: {
		id: "starter",
		name: "Starter",
		baseMonthly: 145,
		modulesMonthlyFlat: 45,
		modulesPerUserMonthly: 0,
		sub: PLAN_SUB_DISCLAIMER,
		features: [
			"Up to 5 active users",
			"People module included",
			"Recruiting module included",
			"AI Sourcing included",
			"Email support",
		],
	},
	growth: {
		id: "growth",
		name: "Growth",
		baseMonthly: 250,
		modulesMonthlyFlat: 0,
		modulesPerUserMonthly: 6,
		sub: PLAN_SUB_DISCLAIMER,
		featured: true,
		features: [
			"25+ active users",
			"People module included",
			"Recruiting module included",
			"AI Sourcing included",
			"Priority email support",
		],
	},
}
